export default __webpack_public_path__ + "static/media/narayan.62f53929.jpeg";